import { Feature, Overlay } from "ol";
import { createRoot } from "react-dom/client";
import InspectOverlay from "./InspectOverlay";
import { Coordinate } from "ol/coordinate";

interface Props {
  feature: Feature;
  position: Coordinate;
}

export default function InspectOverlayView({ feature, position }: Props) {
  const overlayContainer = document.createElement("div");
  const overlayRoot = createRoot(overlayContainer);

  overlayRoot.render(<InspectOverlay feature={feature} />);

  const overlay = new Overlay({
    element: overlayContainer,
    position,
    positioning: "bottom-center",
    offset: [0, feature.get("validation_status") === "NOT_DETECTED" ? 50 : 100],
    stopEvent: false,
  });

  return overlay;
}
